import { useCallback, useEffect, useState } from "react";
import { useOrientationChange } from "./useOrientationChange";
import { useWindowSize } from "./useWindowSize";

export const useVhBody = (): void => {
  const [init, setInit] = useState(false);
  const orientation = useOrientationChange();
  const { height } = useWindowSize();

  const setVhToHtml = useCallback((newHeight: number) => {
    const { documentElement: html } = document;
    // css trick on mobile https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    const vh = newHeight * 0.01;
    html.style.setProperty("--vh", `${vh}px`);
  }, []);

  useEffect(() => {
    setInit(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orientation]);

  useEffect(() => {
    if (height && !init) {
      setTimeout(() => {
        setInit(true);
        setVhToHtml(height);
      }, 100);
    }
  }, [height, init, setVhToHtml]);
};
